import * as React from 'react';

import { SlSkeleton } from '@shoelace-style/shoelace/dist/react';

import { translate } from '~l10n/client';
import { useAccount } from '~teacher/hook/account';

interface NameColumnProps {
  name: string;
  email: string;
  publicId: string;
}

export function NameColumn({ name, email, publicId }: NameColumnProps) {
  const nameQuery = useAccount({
    select: (account) => {
      const isYou = account.publicId === publicId;
      if (isYou) {
        return translate('{0} (You)').format(name);
      } else {
        return name;
      }
    },
  });

  return (
    <div>
      <div className="text-blue-900 text-base leading-8">
        {nameQuery.isLoading ? <SlSkeleton /> : <span>{nameQuery.data}</span>}
      </div>
      <div className="text-gray-500 text-xs leading-7 ">{email}</div>
    </div>
  );
}
